
import { Vue, Component, Prop } from 'vue-property-decorator';
import { IFileCheck } from '@/types/question.d';
import Box from './box.vue';

@Component({
  components: {
    Box,
  },
})
export default class FirstStep extends Vue {
  @Prop() preFiles!: Array<IFileCheck>;
}
